export default __webpack_public_path__ + "static/media/back.f8eff49d.svg";